import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { BatchTypeEnum } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  startDate?: string;
  endDate?: string;
  year?: string;
  groupByShippingMarks?: boolean;
  batchType: BatchTypeEnum;
}

export const useGenerateCustomsRegister = () => {
  return useMutation({
    mutationFn: async ({ startDate, endDate, year, batchType, groupByShippingMarks }: HookProps) => {
      const result = await apiClient.batchesReports.generateCustomsRegister.mutation({
        body: { startDate, endDate, year, batchType, groupByShippingMarks },
      });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      toast.success('The customs register is being generated.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the customs register!');
    },
  });
};
